export enum LogicalOperators {
    exists = 'exists',
    equals = '=',
    notEquals = '!=',
    greater = '>',
    lesser = '<',
    graterOrEqual = '>=',
    lesserOrEqual = '<=',
}
